import dayjs from 'dayjs';

/** Dates are shown the way they are written on a European form. */
export function formatDate(value?: string | null) {
  if (!value) return '';
  return dayjs(value).format('DD.MM.YYYY');
}

export function formatDateTime(value?: string | null) {
  if (!value) return '';
  return dayjs(value).format('DD.MM.YYYY HH:mm');
}

/** Logbook times are UTC and shown as HH:MM, never localised - a Part-FCL page is UTC. */
export function formatUtcTime(value?: string | null) {
  if (!value) return '';
  return value.slice(0, 5);
}

export function formatRelative(value?: string | null) {
  if (!value) return '';
  const days = dayjs(value).diff(dayjs(), 'day');
  if (days === 0) return dayjs(value).format('HH:mm');
  return dayjs(value).format('DD.MM.YYYY');
}

/** Counter readings: hours to one decimal, counts as whole numbers. */
export function formatCounter(value?: string | number | null, unit?: string | null) {
  if (value === null || value === undefined || value === '') return '';
  const asNumber = Number(value);
  if (!Number.isFinite(asNumber)) return String(value);
  return unit === 'COUNT' ? asNumber.toLocaleString() : asNumber.toFixed(1);
}

/**
 * Minutes to "H:MM". Summary endpoints return raw minutes so they can be added up, while
 * flight rows arrive pre-formatted; both end up looking the same on screen.
 */
export function minutesToHhmm(minutes?: number | null) {
  if (minutes === null || minutes === undefined) return '';
  const sign = minutes < 0 ? '-' : '';
  const total = Math.abs(Math.round(minutes));
  return `${sign}${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}

export function formatDecimal(value?: string | number | null, digits = 1) {
  if (value === null || value === undefined || value === '') return '';
  const asNumber = Number(value);
  return Number.isFinite(asNumber) ? asNumber.toFixed(digits) : String(value);
}

/**
 * The pilot in command is written in capitals in every Part-FCL logbook, and the API already
 * returns the name in that form. This exists so a display that builds its own name string
 * cannot quietly break the convention.
 */
export function asPicName(name?: string | null) {
  return (name ?? '').toUpperCase();
}

/** Today as the API wants it, for date pickers that default to now. */
export function today() {
  return dayjs().format('YYYY-MM-DD');
}

export function toApiDate(value: Date | string | null | undefined) {
  if (!value) return null;
  return dayjs(value).format('YYYY-MM-DD');
}

export function fromApiDate(value: string | null | undefined) {
  return value ? dayjs(value).toDate() : null;
}
